/* eslint-disable @typescript-eslint/no-explicit-any */
import intl from 'react-intl-universal'

export const getDictionaries = async () => {
  try {
    return fetch('/spellcheck/dictionaries', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (response.status === 200) {
        return response
          .json()
          .then((data) => {
            return data
          })
          .catch((err) => {
            console.error(err)
          })
      } else {
        return {
          error: intl.get('Spellcheck.api.error'),
        }
      }
    })
  } catch (err) {
    console.error(err)
  }
}

export const addCustomWords = async (customWords) => {
  try {
    return fetch('/spellcheck/words', {
      method: 'POST',
      body: JSON.stringify(customWords),
    }).then((response: any) => {
      if (response.status === 200) {
        return response
          .json()
          .then((data) => {
            return data
          })
          .catch((err) => {
            console.error(err)
          })
      } else {
        return {
          error: intl.get('Spellcheck.api.error'),
        }
      }
    })
  } catch (err) {
    console.error(err)
  }
}

export const deleteCustomWords = async (customWords) => {
  try {
    return fetch('/spellcheck/words', {
      method: 'DELETE',
      body: JSON.stringify(customWords),
    }).then((response) => {
      if (response.status === 200) {
        return response
          .json()
          .then((data) => {
            return data
          })
          .catch((err) => {
            console.error(err)
          })
      } else {
        return { error: intl.get('Spellcheck.api.error') }
      }
    })
  } catch (err) {
    console.error(err)
  }
}

export const spellcheckStory = async (story, language) => {
  try {
    return fetch(`/spellcheck/?dict=${language}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(story),
    }).then((response: any) => {
      if (response.status === 200) {
        return response
          .json()
          .then((data) => {
            return data
          })
          .catch((err) => {
            console.error(err)
          })
      } else {
        return {
          error: intl.get('Spellcheck.api.error'),
        }
      }
    })
  } catch (err) {
    console.error(err)
  }
}

export const getCustomWords = async () => {
  try {
    return fetch('/spellcheck/words', {
      method: 'GET',
    }).then((response: any) => {
      if (response.status === 200) {
        return response
          .json()
          .then((data) => {
            return data
          })
          .catch((err) => {
            console.error(err)
          })
      } else {
        return {
          error: intl.get('Spellcheck.api.error'),
        }
      }
    })
  } catch (err) {
    console.error(err)
  }
}
